import {createActiveOrdersCache$} from '@/spot-utils/orders-active-cache';
import {snapshotOrders$, incrementalOrders$} from '../orders';
import type {ws} from '@/types';

type OpenMarginOrderRaw = ws.OpenMarginOrderRaw;
type ClosedMarginOrderRaw = ws.ClosedMarginOrderRaw;

export const marginActiveOrdersCache$ = createActiveOrdersCache$<OpenMarginOrderRaw | ClosedMarginOrderRaw>(
  snapshotOrders$,
  incrementalOrders$
);
